<template>
  <div class="col">
    <div class="row">
      <p>The following links provide detailed information about the vehicle that may be of assistance.</p>
    </div>
    <span v-if="isLoading">Loading...</span>
    <div v-else class="row custom-result-list">
      <div class="col">
        <ul class="custom-list">
          <li v-for="(link, idx) in links" :key="idx" :class="{ 'custom-list-item': !link.isLine }">
            <hr v-if="link.isLine" />
            <div v-else @click="gotoLink(link.url)">
              <span class="me-2">{{ link.title }}</span>
              <i class="fas fa-external-link-alt"></i>
              <img src="https://opusbroker.blob.core.windows.net/images/OPUS%20IVS%20Ball%20Logo%2032x32.png"
                v-if="!link.isLine && !link.isShop" class="custom-end" alt="OPUS IVS" height="32"
                title="Source from OPUS IVS" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { lookupStore } from '@/stores/lookup'
export default {
  name: 'RepairPlanInfo',
  computed: {
    ...mapState(lookupStore, ['repairPlanItems', 'loading']),
    isLoading() {
      return this.loading?.repairPlanItems
    },
    links() {
      let _links = []
      let last = null
      let item = null
      if (this.repairPlanItems && this.repairPlanItems.length > 0) {
        console.log('repairPlanItems:', this.repairPlanItems)
        last = this.repairPlanItems[0]
        for (let i = 1; i < this.repairPlanItems.length; i++) {
          item = this.repairPlanItems[i]
          if (last.isShop && item.isShop === false) {
            _links.push({
              title: last.title,
              url: last.url,
              isLine: false,
              isShop: item.isShop
            })
            _links.push({
              title: last.title,
              url: last.url,
              isLine: true,
              isShop: item.isShop
            })
          } else {
            _links.push({
              title: last.title,
              url: last.url,
              isLine: false,
              isShop: item.isShop
            })
          }
          last = item
        }
      }
      return _links
    }
  },
  methods: {
    gotoLink(url) {
      if (url) {
        window.open(url, '_blank')
      } else {
        console.error('No valid URL found for the link')
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.custom-result-list {
  width: 100%;
  height: 550px;
  max-height: 550px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-top: 15px;
}

.custom-list {
  list-style-type: none;

  li {
    padding: 5px;
  }

  li.custom-list-item {
    div {
      width: 100%;
      font-size: 1.0em;
      font-weight: 500;
      margin-bottom: 8px;
    }
  }

  li.custom-list-item:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
}

.custom-end {
  float: right;
  width: 32px;
  height: 32px;
  padding: 7px;
}
</style>